import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicTextArea, BaasicDropdown, BasicInput, NumericInputField, BaasicFieldDropdown, BasicFieldCheckbox, BaasicButton, BaasicModal, BaasicFormControls } from 'core/components';
import { Content } from 'core/layouts';
import { FacilityAdditionalContactEdit, FacilityAdditionalContactBulkCreate, BulkEmrModal, FacilityPayerValidationModal } from 'application/facility/components';
import { GlobalBeforeUnloadListener } from 'core/components';
import { emailRecipientTypes } from 'core/utils';

function FacilityEditTemplate({ editView, t }) {
    const {
        item,
        contentLoading,
        form,
        facilityStore,
        branchStore,
        accountRepStore,
        purchaseRepStore,
        intakeRepStore,
        woundCareRepStore,
        payorRepStore,
        documentRepStore,
        billingRepStore,
        areasConstructed,
        corporateStore,
        jurisdictionStore,
        cbaStore,
        contactEditModal,
        onAddAditionalContact,
        additionalContactBulkCreateModal,
        onBulkCreateAditionalContact,
        authorization,
        additionalContacts,
        onDeleteAdditionalContact,
        onActivateAditionalContact,
        pumpBrandStore,
        spikeSetStore,
        syringeStore,
        rootStore,
        openBulkEmrModal,
        bulkEmrModal,
        facilityPayerValidationModal,
        openPayerValidationModal,
        openCorporate,
        saveResource,
        drainageBagStore,
        isSavingResource,
        syncAddress,
        isAddressSynchronization,
        eSignPreferenceStore,
        isChanged,
        mainVendorStore,
        initialIntakeRepStore,
        insuranceReviewRepStore,
        confirmingRepStore,
        pricingGroupStore,
        // ISG-2961: used only by the hidden sync icon.
        // isSyncing,
        // syncNikoPriceGroups
    } = editView;
    const areasOfCares = item && areasConstructed ? item.facilityAreaOfCares.map(i =>
        <div className="row" key={i.areaOfCareId}>
            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                {i.areaOfCare.name}
            </div>
            <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                <BaasicFieldDropdown field={form.$('areaOfCares').$('item-' + i.id).$('coverageTypeId')} store={i.coverageTypeStore} />
            </div>
        </div>
    ) : [];

    let additionalContactsRows = additionalContacts != null ? additionalContacts.filter(i => !i.inActive).map(contact => {
        return (<tr key={contact.id} className={contact.inActive ? 'inactive' : ''}>
            <td>
                {contact.name}
            </td>
            <td>
                {contact.lastName}
            </td>
            <td>
                {contact.departments}
            </td>
            <td>
                {contact.email}
            </td>
            <td>
                {contact.note}
            </td>
            <td className="u-cursor--default type--left">
                {emailRecipientTypes.map((setting) => {
                    return contact[setting.field] && contact[setting.field] !== '' && <div key={setting.field} className={`status--include ${contact.inActive ? 'is-inactive' : `is-${contact[setting.field]}`}`}>{setting.name}</div>
                })}
            </td>
            <td className="type--right">
                <div className="table__icons">
                    <button type="button" onClick={() => onActivateAditionalContact(contact)} className="btn btn--icon">
                        <i className={`u-icon u-icon--${contact.inActive ? 'inactive-grey' : 'active-blue'} u-icon--sml`} title={contact.inActive ? 'Inactive' : 'Active'}></i>
                    </button>
                    <button type="button" onClick={() => onAddAditionalContact(contact)} className="btn btn--icon">
                        <i title={"Edit"} className="u-icon u-icon--edit u-icon--sml"></i>
                    </button>
                    <div className="table__icons">
                        <BaasicButton
                            authorization={
                                authorization ? authorization.delete : null
                            }
                            className="btn btn--icon is-delete"
                            icon="u-icon u-icon--delete u-icon--sml"
                            label="Delete"
                            onlyIcon={true}
                            onClick={() => onDeleteAdditionalContact(contact)}
                        ></BaasicButton>
                    </div>
                </div>
            </td>
        </tr>)
    }) : null;

    let additionalInActiveContactsRows = additionalContacts != null ? additionalContacts.filter(i => i.inActive).map(contact => {
        return (
            <tr key={contact.id} className={contact.inActive ? 'inactive' : ''}>
                <td>
                    {contact.name}
                </td>
                <td>
                    {contact.lastName}
                </td>
                <td>
                    {contact.departments}
                </td>
                <td>
                    {contact.email}
                </td>
                <td>
                    {contact.note}
                </td>
                <td className="u-cursor--default type--left">
                    {emailRecipientTypes.map((setting) => {
                        return contact[setting.field] && contact[setting.field] !== '' && <div className={`status--include ${contact.inActive ? 'is-inactive' : `is-${contact[setting.field]}`}`}>{setting.name}</div>
                    })}
                </td>
                <td className="type--right">
                    <div className="table__icons">
                        <button type="button" onClick={() => onActivateAditionalContact(contact)} className="btn btn--icon">
                            <i className={`u-icon u-icon--${contact.inActive ? 'inactive-grey' : 'active-blue'} u-icon--sml`} title={contact.inActive ? 'Inactive' : 'Active'}></i>
                        </button>
                        <button type="button" onClick={() => onAddAditionalContact(contact)} className="btn btn--icon">
                            <i title={"Edit"} className="u-icon u-icon--edit u-icon--sml"></i>
                        </button>
                        <div className="table__icons">
                            <BaasicButton
                                authorization={
                                    authorization ? authorization.delete : null
                                }
                                className="btn btn--icon is-delete"
                                icon="u-icon u-icon--delete u-icon--sml"
                                label="Delete"
                                onlyIcon={true}
                                onClick={() => onDeleteAdditionalContact(contact)}
                            ></BaasicButton>
                        </div>
                    </div>
                </td>
            </tr>)
    }) : null;

    return (
        <div className="container">
            <form onSubmit={form.onSubmit}>
                {item && <h2 className="content__header is-legacy"> Facility: {item.name}
                    <div className="u-flex--primary u-flex--grow--1">
                        <BaasicButton
                            className="btn btn--icon"
                            icon="u-icon u-icon--med u-icon--schedules"
                            label="Calendar"
                            onlyIcon={true}
                            onClick={() =>
                                window.open(
                                    `${rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${item.id}`
                                )}
                        ></BaasicButton>
                    </div>
                </h2>}
                <div className="content__main">
                    <Content loading={contentLoading} >
                        <GlobalBeforeUnloadListener isChanged={isChanged} />
                        {item && item.payersNeedAttention &&
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-9">
                                    <div className="card card--outlined--featured card--outlined--note card--xsml card--flex u-mar--bottom--med">
                                        <div className="u-flex--space-between">
                                            <div>
                                                <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                                {t('FACILITY.PAYERS_NEED_ATTENTION')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        <div className="row u-mar--bottom--sml">
                            <div className="col col-sml-12 col-lrg-9">
                                <div className="content__header__actions">
                                    <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Save and Go Back" />
                                    <BaasicButton
                                        className='btn btn--base btn--primary'
                                        label="Save"
                                        onClick={() => saveResource()}
                                        rotate icon={
                                            isSavingResource
                                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                                : 'u-display--none'
                                        }
                                        disabled={isSavingResource}
                                    />
                                    <BaasicButton
                                        className="btn btn--base btn--primary"
                                        label="History"
                                        onClick={() =>
                                            window.open(
                                                `${rootStore.routerStore.findRoute('master.app.main.facility.facility-history.list').pattern}?facilityId=${item.id}`
                                            )}
                                        icon="u-display--none"
                                    />
                                    {item && !item.isNiko &&
                                        <BaasicButton
                                            className='btn btn--base btn--primary'
                                            label="Sync Address"
                                            onClick={() => syncAddress()}
                                            rotate icon={
                                                isAddressSynchronization
                                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                                    : 'u-display--none'
                                            }
                                            disabled={isAddressSynchronization}
                                        />
                                    }
                                    {item && item.isNiko &&
                                        <BaasicButton
                                            className='btn btn--base btn--primary'
                                            label="Update Facility Payers"
                                            onClick={() => openPayerValidationModal()}
                                            icon="u-display--none"
                                        />
                                    }
                                    <BaasicButton
                                        className='btn btn--base btn--ghost cancel'
                                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                                        onClick={() => rootStore.routerStore.goBack()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="u-mar--bottom--sml">
                            <div className="row">
                                <div className="col col-sml-12 col-med-6 col-lrg-6 col-xxlrg-4">
                                    <div className="inputgroup">
                                        <div className="inputgroup--main">
                                            <BaasicDropdown
                                                store={facilityStore}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col col-sml-12 col-lrg-9">
                                <div className="card card--form card--primary card--med">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <h4 className="form__title">
                                                General data
                                            </h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('name')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('oldName')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('address')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('phone')} />
                                                </div>
                                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('inActive')} /><span className="fake-label">Inactive</span>
                                                </div>
                                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('isOnHold')} /><span className="fake-label">Is On Hold</span>
                                                </div>
                                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('isNew')} /><span className="fake-label">Is New</span>
                                                </div>
                                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('isNewFlow2')} /><span className="fake-label">Is New Flow 2</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('accountRepId')} store={accountRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('billingRepId')} store={billingRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('documentRepId')} store={documentRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('payorRepId')} store={payorRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('intakeRepId')} store={intakeRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('initialIntakeRepId')} store={initialIntakeRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('insuranceReviewRepId')} store={insuranceReviewRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('woundCareRepId')} store={woundCareRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('purchaseRepId')} store={purchaseRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('confirmingRepId')} store={confirmingRepStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <div className="input--dropdown--align">
                                                        <div className='form__group__label'>Corporate <a onClick={openCorporate} className="u-icon u-icon--preview u-icon--sml"></a></div>
                                                    </div>
                                                    <BaasicFieldDropdown allowEmpty={rootStore.userStore.applicationUser && rootStore.userStore.applicationUser.roles.includes("Administrators")} field={form.$('corporateId')} store={corporateStore} labelDisplayed={false} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('jurisdiction')} store={jurisdictionStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('cba')} store={cbaStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('branchId')} store={branchStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('payorInformation')} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('priceTable')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <div className="form__group__label">
                                                        Pricing Group
                                                        {/* ISG-2961: required mark and sync icon hidden while the field is read-only. */}
                                                        {/* {<React.Fragment>Pricing Group<span className="validation__mark">*</span></React.Fragment>} */}
                                                        {/* <i title='Sync Pricing Group' className={`u-icon u-icon--sml u-icon--synchronize--${isSyncing ? "grey" : "primary"} u-mar--left--tny`} onClick={ isSyncing ? () => {} : () => syncNikoPriceGroups()}></i> */}
                                                    </div>
                                                    {/* ISG-2961: read-only while NikoHealth pricing groups are unavailable; the saved value is still sent on update. */}
                                                    <BaasicFieldDropdown disabled allowEmpty={false} field={form.$('pricingGroupId')} store={pricingGroupStore} labelDisplayed={false} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('marketingRep')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('masterPatientId')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('fastcareId')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <NumericInputField field={form.$('emergencySupplyDays')} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('shippingVendor')} />
                                                </div>
                                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                                    <NumericInputField field={form.$('shipPoint')} />
                                                </div>
                                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                                    <NumericInputField field={form.$('shipPointUnited')} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('mainVendorId')} store={mainVendorStore} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('invoicedMonthly')} /><span className="fake-label">Invoiced Monthly</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('requiredSecondPayor')} /><span className="fake-label">2nd Payor Check Required</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('partBOnly')} disabled={true} /><span className="fake-label">Part B Only</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('pumpsNotSetInitially')} /><span className="fake-label">Pumps Not Set Initially</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('isPumpRentalItem')} /><span className="fake-label">Pump Rental Item</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('isAutoSupplyEnfitAdapter')} /><span className="fake-label">Auto-supply ENFIT adapter</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('doNotSendIVPoles')} /><span className="fake-label">Don't send IV Poles</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('sendAgoraPo')} /><span className="fake-label">Send Agora PO</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('isMonthlyTrachTube')} /><span className="fake-label">Send Trach Tubes Monthly</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('documentationHold')} /><span className="fake-label">Documentation Hold</span>
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicFieldCheckbox className="has-fake-label" field={form.$('isSAPs')} /><span className="fake-label">SAPs</span>
                                                </div>
                                            </div>
                                            <h4 className="form__title u-mar--top--med">Default Products</h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('pumpBrandId')} store={pumpBrandStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('spikeSetId')} store={spikeSetStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('syringeId')} store={syringeStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('drainageBagId')} store={drainageBagStore} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <h4 className="form__title">Areas of Care</h4>
                                            {item && item.isNiko && 
                                            <div className="card card--outlined--featured card--outlined--note card--xsml card--flex u-mar--bottom--med">
                                            <div className="u-flex--space-between">
                                                <div>
                                                    <i className="u-icon u-icon--sml u-icon--warning-triangle u-mar--right--sml"></i>
                                                    Updating Coverage Types for Areas of Care will update all templates.
                                                </div>
                                            </div>
                                        </div>}
                                            {areasOfCares}
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <div>
                                                <h4 className="form__title">EMR Info</h4>
                                            </div>
                                            <BaasicButton
                                                authorization={authorization ? authorization.update : null}
                                                className="btn btn--base btn--primary u-mar--bottom--sml"
                                                label='Bulk Update'
                                                onClick={() => openBulkEmrModal()}
                                                disabled={!(item && !!item.emr && !!item.emrUserName)}
                                            >
                                            </BaasicButton>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('emr')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('emrAccountName')} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('emrUserName')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('emrPassword')} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('uniqueCode')} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12">
                                            <h4 className="form__title">Contacts</h4>
                                            {additionalContactsRows && additionalContactsRows.length > 0 &&
                                                <table className="table--preview u-mar--bottom--med">
                                                    <colgroup>
                                                        <col />
                                                        <col />
                                                        <col />
                                                        <col />
                                                        <col />
                                                        <col width="160" />
                                                        <col width="90" />
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th className="type--left">First Name</th>
                                                            <th className="type--left">Last Name</th>
                                                            <th className="type--left">Department</th>
                                                            <th className="type--left">Email</th>
                                                            {/* <th className="type--left">Phone</th>
                                                    <th className="type--left">Extension</th> */}
                                                            <th className="type--left">Note</th>
                                                            <th className="type--left">Include On</th>
                                                            <th className="type--right">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{additionalContactsRows}</tbody>
                                                </table>}
                                            <div className="u-mar--bottom--sml"></div>
                                        </div>
                                        {additionalInActiveContactsRows && additionalInActiveContactsRows.length > 0 && (
                                            <CollapsibleSection title="Contacts" defaultCollapsed={true}>
                                                <table className="table--preview u-mar--bottom--med">
                                                    <colgroup>
                                                        <col />
                                                        <col />
                                                        <col />
                                                        <col />
                                                        <col />
                                                        <col width="160" />
                                                        <col width="90" />
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th className="type--left">First Name</th>
                                                            <th className="type--left">Last Name</th>
                                                            <th className="type--left">Department</th>
                                                            <th className="type--left">Email</th>
                                                            <th className="type--left">Note</th>
                                                            <th className="type--left">Include On</th>
                                                            <th className="type--right">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{additionalInActiveContactsRows}</tbody>
                                                </table>
                                            </CollapsibleSection>
                                        )}
                                        <div className='col col-sml-12 col-lrg-12 u-mar--bottom--med'>
                                            <BaasicButton
                                                authorization={authorization ? authorization.update : null}
                                                className="btn btn--base btn--primary u-mar--left--auto u-mar--right--tny"
                                                label='Add Contact'
                                                onClick={() => onAddAditionalContact()}>
                                            </BaasicButton>
                                            <BaasicButton
                                                authorization={authorization ? authorization.update : null}
                                                className="btn btn--base btn--primary u-mar--left--auto"
                                                label='Bulk Add'
                                                onClick={() => onBulkCreateAditionalContact()}>
                                            </BaasicButton>
                                        </div>
                                        <BaasicModal modalParams={contactEditModal} className="modal__content modal--med">
                                            <FacilityAdditionalContactEdit />
                                        </BaasicModal>
                                        <BaasicModal className="modal__content modal--sml" modalParams={additionalContactBulkCreateModal}>
                                            <FacilityAdditionalContactBulkCreate />
                                        </BaasicModal>
                                        <BaasicModal className="modal__content ReactModal__Content--large" modalParams={bulkEmrModal}>
                                            <BulkEmrModal />
                                        </BaasicModal>
                                        <BaasicModal className="modal__content modal--med" modalParams={facilityPayerValidationModal}>
                                            <FacilityPayerValidationModal />
                                        </BaasicModal>

                                        <div className="col col-sml-12 col-lrg-12">
                                            <h4 className="form__title">Notes</h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicTextArea field={form.$('notes')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicTextArea field={form.$('deliveryNote')} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicTextArea multiLineEdit={true} field={form.$('generalNote')} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12">
                                            <h4 className="form__title">E-Sign</h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('eSignPreferenceId')} store={eSignPreferenceStore} />
                                                </div>
                                                <div className="form__group col col-lrg-6 u-mar--bottom--sml">
                                                    <BasicTextArea multiLineEdit={true} field={form.$('eSignNote')} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Content>
                </div>
                <div className='content__footer'>
                    <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Save and Go Back" />
                    <BaasicButton
                        className='btn btn--base btn--primary'
                        label="Save"
                        onClick={() => saveResource()}
                        rotate icon={
                            isSavingResource
                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                : 'u-display--none'
                        }
                        disabled={isSavingResource}
                    />
                    <BaasicButton
                        className='btn btn--base btn--ghost'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={() => rootStore.routerStore.goBack()}
                    />
                </div>
            </form>
        </div>
    )
}

FacilityEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

class CollapsibleSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { collapsed: props.defaultCollapsed !== undefined ? props.defaultCollapsed : true };
    }

    toggle = () => {
        this.setState(function (prevState) {
            return { collapsed: !prevState.collapsed };
        });
    };

    render() {
        const children = this.props.children;
        const collapsed = this.state.collapsed;

        return (
            <div className="col col-sml-12 col-lrg-12">
                <div className="u-mar--bottom--sml" style={{ display: 'inline-block', cursor: 'pointer' }} onClick={this.toggle}>
                    <span>Inactive Contacts</span>
                    <span className={!collapsed ? "u-icon u-icon--med u-icon--arrow-up u-mar--left--sml" : "u-icon u-icon--med u-icon--arrow-down u-mar--left--sml"}></span>
                </div>
                {!collapsed && (
                    <div>
                        {children}
                    </div>
                )}
            </div>
        );
    }
}

CollapsibleSection.propTypes = {
    title: PropTypes.string.isRequired,
    defaultCollapsed: PropTypes.bool,
    children: PropTypes.node
};

export default defaultTemplate(FacilityEditTemplate);
